export const TOTALS_SUFFIX = '___totals';
/** Flag the server sets on gap-filled rows: metrics and GROUP_TOTALS columns are zeroed there. */
export const GAP_ROW_KEY = '_gap';
export const COMPARE_PREFIX = 'comparison___';
export const COMPARE_SUFFIX = '___previous_period';
export const COMPARE_TOTALS_SUFFIX = `${COMPARE_SUFFIX}${TOTALS_SUFFIX}`;
